import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function AuthLayout() {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  // Already signed in? Don't expose auth pages.
  if (token) return <Navigate to="/dashboard" replace />;

  // Always show intro before login page.
  if (location.pathname === '/login' && !location.state?.fromIntro) {
    return <Navigate to="/intro" replace state={location.state} />;
  }

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f2f4f8]">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_85%_50%_at_50%_-10%,rgba(59,130,246,0.08),transparent)]" />

      <div className="relative mx-auto flex min-h-screen w-full max-w-6xl items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_10px_28px_rgba(15,23,42,0.08)] backdrop-blur-xl sm:p-8">
          <div className="mb-5 flex items-center justify-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 via-indigo-600 to-violet-600 text-white shadow-md shadow-blue-500/30">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12l5 5L20 7" />
              </svg>
            </div>
            <span className="text-sm font-semibold text-indigo-600">Publish</span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
